// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ede2cc13","239":"37618f89","337":"5f121489","607":"ff42a17f","657":"b90cb614","732":"be7fbf8b","941":"e71c9c54"}[chunkId] + ".chunk.js";
};